import { useEffect, useState } from 'react';
import {
  getDesignSystem,
  subscribeDesignSystem,
} from './designSystemStore';

export const useDesignSystem = () => {
  const [designSystem, setDesignSystem] = useState(getDesignSystem());

  useEffect(() => {
    const unsubscribe = subscribeDesignSystem(() => {
      setDesignSystem(getDesignSystem());
    });

    return unsubscribe;
  }, []);

  return designSystem;
};
